import React from "react";
import { IoMdHome } from "react-icons/io";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <div className="headers">
      <h2>Spin & Win</h2>
      <Link to="/">
        <IoMdHome size={30} />
      </Link>
    </div>
  );
}
